import React from "react";
import { motion } from "framer-motion";
import benzzpark from "../Assets/benz.png";
import swamysweets from "../Assets/SWAMY SWEETS.png";
import galaxycinemas from "../Assets/GALAXY CINEMS.png";
import kalamkids from "../Assets/KALAM KIDS.png";
import kasimgroups from "../Assets/KASIM GROUPS.png";
import ltc from "../Assets/LTC.png";
import brightboss from "../Assets/BRIGHT BOSS.png";
import greenarcade from "../Assets/GREEN ARCADE.png";
import greeneco from "../Assets/GREEN ECO.png";
import harishelectricals from "../Assets/HARISH ELECRICALS.png";
import dhivyamclinic from "../Assets/DHIVYAM CLINIC.png";
import dis from "../Assets/DIS.png";
import kalamjiacademy from "../Assets/KALAM JI ACADEMY.png";
import saisteels from "../Assets/SAI STEELS.png";
import aryaas from "../Assets/ARYAAS.png";
import shine from "../Assets/SHINE@300x-8.png";
import skcycles from "../Assets/SK CYCLES.png";
import RDSIT from "../Assets/RDS IT@300x-8.png";
import rdsenclave from "../Assets/RDS ENCLAVE@300x-8.png";
import rdsmart from "../Assets/RDS SUPERMART@300x-8 (1).png";
import tony from "../Assets/tony.png";


// Unique clients list
const clients = [
  benzzpark, galaxycinemas, swamysweets, brightboss, RDSIT, rdsenclave, rdsmart, dis,
  greenarcade, greeneco, harishelectricals, dhivyamclinic, saisteels, aryaas,tony,

  shine, skcycles,  kalamkids, ltc, kasimgroups, kalamjiacademy,
 
  
];

const OurClients = () => {
  return (
    <div className="py-10">
      <h1 className="text-3xl font-bold text-center">Our Clients</h1>
      <div className="overflow-hidden relative w-full space-y-6">
        {/* First Row */}
        <motion.div
          className="flex space-x-6 items-center"
          animate={{ x: ["100%", "-100%"] }}
          transition={{ 
            ease: "linear",
            repeat: Infinity, 
            duration: 15,
          }}
        >

          {clients.map((client, index) => (
            <img
              key={`row1-${index}`}
              src={client}
              alt={`Client Logo ${index + 1}`}
              className="h-20 px-6 w-auto object-contain bg-white bg-opacity-10 backdrop-blur-md shadow-xl p-2 rounded-2xl border border-white border-opacity-20 mt-4"
            />
          ))}
        </motion.div>
        {/* Second Row - Reverse Scroll */}
        <motion.div
          className="flex space-x-6 items-center"
          animate={{ x: ["-100%", "100%"] }}
          transition={{
            ease: "linear",
            repeat: Infinity,
            duration: 15,
          }}
        >
          {clients.reverse().map((client, index) => (
            <img
              key={`row2-${index}`}
              src={client}
              alt={`Client Logo ${index + 1}`}
              className="h-20 px-6 w-auto object-contain bg-white bg-opacity-10 backdrop-blur-md shadow-xl p-2 rounded-2xl border border-white border-opacity-20 mt-4"
            />
          ))}
        </motion.div>
      </div>
    </div>
  );
};

export default OurClients;
  